// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"6kDkD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initReportLogging", ()=>initReportLogging);
parcelHelpers.export(exports, "initContentLogging", ()=>initContentLogging);
var _utilsJs = require("./utils.js");
const LOGGING_CONFIG = {
    REPORT_URL_INDICES: {
        FORMAT: 1,
        ID: 2,
        TYPE: 3
    },
    DEFAULT_VALUES: {
        REPORT_TYPE: "parent",
        REPORT_ID: "",
        REPORT_FORMAT: null
    },
    PARAMETERS: {
        ECP_SUFFIX: "-ecp",
        VISION_SIMULATOR: "click-vision-simulator",
        TOOLTIP: "click-info",
        ACCORDION: "expand-section",
        EYE_TOGGLE: "click-eye"
    },
    SUBSECTIONS: {
        MEYE_GAUGE: "meye-gauge",
        MEYE_GUIDE: "meye-guide",
        MEYE_SCORE: "meye-score"
    }
};
const REPORT_FORMAT_MAPPINGS = {
    "qr-meye": LOGGING_CONFIG.SUBSECTIONS.MEYE_GUIDE,
    "qr-score": LOGGING_CONFIG.SUBSECTIONS.MEYE_SCORE
};
const MYOPIA_COMPARE_SECTION = "myopia-compare";
const VISION_SIMULATOR_SECTION = "vision-simulator";
const MYOPIA_MANAGEMENT_HELP_SECTION = "myopia-management-help";
const AXIAL_LENGTH_ANALYSIS_SECTION = "axial-length-analysis";
const TREATMENTS_AVAILABLE_SECTION = "treatments-available";
const WHAT_ELSE_SECTION = "what-else-can-we-do";
const MYOPIA_CHANGED_SECTION = "myopia-changed";
const MYOPIA_EYES_GROWN = "eyes-grown";
const IMPORTANT_TO_REMEMBER_SECTION = "important-to-remember";
const TREATMENT_SUMMARY = "treatment-summary";
const SCORE_CARD = "score-card";
const TREATMENT_OPTIMIZATION = "treatment-optimization";
const EVENT_TYPE_CONTENT = "content";
const ELEMENT_ID_TO_SECTION_MAPPING = [
    {
        patterns: [
            MYOPIA_COMPARE_SECTION,
            "compare-md"
        ],
        sectionID: MYOPIA_COMPARE_SECTION,
        subsectionID: null,
        parseEye: true
    },
    {
        patterns: [
            "vision-simulator-button",
            "eye-simulator-tab"
        ],
        sectionID: VISION_SIMULATOR_SECTION,
        subsectionID: null,
        parseEye: false
    },
    {
        patterns: [
            "vision-simulator-now"
        ],
        sectionID: VISION_SIMULATOR_SECTION,
        subsectionID: "sees-now",
        parseEye: true
    },
    {
        patterns: [
            "vision-simulator-adult"
        ],
        sectionID: VISION_SIMULATOR_SECTION,
        subsectionID: "sees-as-adult",
        parseEye: true
    },
    {
        patterns: [
            MYOPIA_MANAGEMENT_HELP_SECTION,
            "myopia-help-tab"
        ],
        sectionID: MYOPIA_MANAGEMENT_HELP_SECTION,
        subsectionID: null,
        parseEye: false
    },
    {
        patterns: [
            AXIAL_LENGTH_ANALYSIS_SECTION,
            "tooltip-axial-length",
            "axial-length-eyes"
        ],
        sectionID: AXIAL_LENGTH_ANALYSIS_SECTION,
        subsectionID: null,
        parseEye: true
    },
    {
        patterns: [
            "axial-length-treatment-targets"
        ],
        sectionID: AXIAL_LENGTH_ANALYSIS_SECTION,
        subsectionID: "treatment-targets",
        parseEye: true
    },
    {
        patterns: [
            TREATMENTS_AVAILABLE_SECTION
        ],
        sectionID: TREATMENTS_AVAILABLE_SECTION,
        subsectionID: null,
        parseEye: false
    },
    {
        patterns: [
            "available-treatments-spectacles"
        ],
        sectionID: TREATMENTS_AVAILABLE_SECTION,
        subsectionID: "spectacles",
        parseEye: false
    },
    {
        patterns: [
            "available-treatments-contact-lenses"
        ],
        sectionID: TREATMENTS_AVAILABLE_SECTION,
        subsectionID: "contact-lenses",
        parseEye: false
    },
    {
        patterns: [
            "available-treatments-overnight-contact-lenses"
        ],
        sectionID: TREATMENTS_AVAILABLE_SECTION,
        subsectionID: "overnight-contact-lenses",
        parseEye: false
    },
    {
        patterns: [
            "available-treatments-controlled-release-lenses"
        ],
        sectionID: TREATMENTS_AVAILABLE_SECTION,
        subsectionID: "controlled-release-contact-lenses",
        parseEye: false
    },
    {
        patterns: [
            "available-treatments-eye-drops"
        ],
        sectionID: TREATMENTS_AVAILABLE_SECTION,
        subsectionID: "eye-drops",
        parseEye: false
    },
    {
        patterns: [
            WHAT_ELSE_SECTION
        ],
        sectionID: WHAT_ELSE_SECTION,
        subsectionID: null,
        parseEye: false
    },
    {
        patterns: [
            "what-else-outdoor-time"
        ],
        sectionID: WHAT_ELSE_SECTION,
        subsectionID: "outdoor-time",
        parseEye: false
    },
    {
        patterns: [
            "what-else-near-work"
        ],
        sectionID: WHAT_ELSE_SECTION,
        subsectionID: "near-work",
        parseEye: false
    },
    {
        patterns: [
            "what-else-screen-time"
        ],
        sectionID: WHAT_ELSE_SECTION,
        subsectionID: "screen-time",
        parseEye: false
    },
    {
        patterns: [
            "what-else-eye-checks"
        ],
        sectionID: WHAT_ELSE_SECTION,
        subsectionID: "eye-checks",
        parseEye: false
    },
    {
        patterns: [
            MYOPIA_CHANGED_SECTION
        ],
        sectionID: MYOPIA_CHANGED_SECTION,
        subsectionID: null,
        parseEye: true
    },
    {
        patterns: [
            "overall-progression-trigger"
        ],
        sectionID: MYOPIA_CHANGED_SECTION,
        subsectionID: "overall-progression",
        parseEye: true
    },
    {
        patterns: [
            "treatment-benefit-trigger"
        ],
        sectionID: MYOPIA_CHANGED_SECTION,
        subsectionID: "treatment-benefit",
        parseEye: true
    },
    {
        patterns: [
            "treatment-stability-trigger"
        ],
        sectionID: MYOPIA_CHANGED_SECTION,
        subsectionID: "treatment-stability",
        parseEye: true
    },
    {
        patterns: [
            MYOPIA_EYES_GROWN
        ],
        sectionID: MYOPIA_EYES_GROWN,
        subsectionID: null,
        parseEye: true
    },
    {
        patterns: [
            "first-chart-myopia-graph"
        ],
        sectionID: MYOPIA_CHANGED_SECTION,
        subsectionID: "first-chart",
        parseEye: true
    },
    {
        patterns: [
            "overall-efficacy-trigger"
        ],
        sectionID: MYOPIA_CHANGED_SECTION,
        subsectionID: "overall-efficacy",
        parseEye: true
    },
    {
        patterns: [
            "centile-chart-myopia-graph"
        ],
        sectionID: MYOPIA_CHANGED_SECTION,
        subsectionID: "centile-chart",
        parseEye: true
    },
    {
        patterns: [
            "first-chart-axial-length-graph"
        ],
        sectionID: MYOPIA_EYES_GROWN,
        subsectionID: "first-chart",
        parseEye: true
    },
    {
        patterns: [
            "centile-chart-axial-length-graph"
        ],
        sectionID: MYOPIA_EYES_GROWN,
        subsectionID: "centile-chart",
        parseEye: true
    },
    {
        patterns: [
            "overall-growth-progression-trigger"
        ],
        sectionID: MYOPIA_EYES_GROWN,
        subsectionID: "overall-growth-progression",
        parseEye: true
    },
    {
        patterns: [
            "treatment-growth-benefit-trigger"
        ],
        sectionID: MYOPIA_EYES_GROWN,
        subsectionID: "treatment-growth-progression",
        parseEye: true
    },
    {
        patterns: [
            "treatment-growth-stability-trigger"
        ],
        sectionID: MYOPIA_EYES_GROWN,
        subsectionID: "treatment-stability",
        parseEye: true
    },
    {
        patterns: [
            "treatment-summary-accordion"
        ],
        sectionID: TREATMENT_SUMMARY,
        subsectionID: null,
        parseEye: false
    },
    {
        patterns: [
            SCORE_CARD
        ],
        sectionID: SCORE_CARD,
        subsectionID: null,
        parseEye: true
    },
    {
        patterns: [
            "tooltip-score-treatment-benefit"
        ],
        sectionID: SCORE_CARD,
        subsectionID: "short-followup",
        parseEye: true
    },
    {
        patterns: [
            IMPORTANT_TO_REMEMBER_SECTION
        ],
        sectionID: IMPORTANT_TO_REMEMBER_SECTION,
        subsectionID: null,
        parseEye: false
    },
    {
        patterns: [
            "collapse-treatment-info-"
        ],
        sectionID: IMPORTANT_TO_REMEMBER_SECTION,
        subsectionSource: "content-info",
        parseEye: false
    },
    {
        patterns: [
            "treatment-optimization-button"
        ],
        sectionID: TREATMENT_OPTIMIZATION,
        subsectionID: null,
        parseEye: false
    },
    {
        patterns: [
            "collapse-treatment-trigger"
        ],
        sectionID: TREATMENT_OPTIMIZATION,
        subsectionID: "use-treatment-correctly",
        parseEye: false
    },
    {
        patterns: [
            "collapse-screentime-trigger"
        ],
        sectionID: TREATMENT_OPTIMIZATION,
        subsectionID: "screentime-and-reading",
        parseEye: false
    },
    {
        patterns: [
            "collapse-outdoors-trigger"
        ],
        sectionID: TREATMENT_OPTIMIZATION,
        subsectionID: "time-outdoors",
        parseEye: false
    }
];
const SECTION_PRODUCTS = "products-button";
const SECTION_MENU = "products-menu";
const NAVIGATION_ID_TO_SECTION_MAPPING = [
    {
        patterns: [
            "display-tac"
        ],
        sectionID: "display-tac",
        subsectionID: ""
    },
    {
        patterns: [
            "display-privacy"
        ],
        sectionID: "display-privacy",
        subsectionID: ""
    },
    {
        patterns: [
            "ocumetra-home-button"
        ],
        sectionID: "home-button",
        subsectionID: ""
    },
    {
        patterns: [
            "navbar-products-desktop-button",
            "navbar-products-mobile-button"
        ],
        sectionID: SECTION_MENU,
        subsectionID: ""
    },
    {
        patterns: [
            "navbar-products-meye-gauge"
        ],
        sectionID: SECTION_MENU,
        subsectionID: LOGGING_CONFIG.SUBSECTIONS.MEYE_GAUGE
    },
    {
        patterns: [
            "navbar-products-meye-guide"
        ],
        sectionID: SECTION_MENU,
        subsectionID: LOGGING_CONFIG.SUBSECTIONS.MEYE_GUIDE
    },
    {
        patterns: [
            "navbar-products-meye-score"
        ],
        sectionID: SECTION_MENU,
        subsectionID: LOGGING_CONFIG.SUBSECTIONS.MEYE_SCORE
    },
    {
        patterns: [
            "navbar-resources-button"
        ],
        sectionID: "menu-button",
        subsectionID: "resources"
    },
    {
        patterns: [
            "navbar-reports-button"
        ],
        sectionID: "menu-button",
        subsectionID: "reports"
    },
    {
        patterns: [
            "navbar-language-button"
        ],
        sectionID: "language",
        subsectionID: ""
    },
    {
        patterns: [
            "navbar-language-link"
        ],
        sectionID: "language",
        subsectionSource: "data-lang-code"
    },
    {
        patterns: [
            "launch-gauge-button"
        ],
        sectionID: SECTION_PRODUCTS,
        subsectionID: LOGGING_CONFIG.SUBSECTIONS.MEYE_GAUGE
    },
    {
        patterns: [
            "launch-guide-button"
        ],
        sectionID: SECTION_PRODUCTS,
        subsectionID: LOGGING_CONFIG.SUBSECTIONS.MEYE_GUIDE
    },
    {
        patterns: [
            "launch-score-button"
        ],
        sectionID: SECTION_PRODUCTS,
        subsectionID: LOGGING_CONFIG.SUBSECTIONS.MEYE_SCORE
    },
    {
        patterns: [
            "upgrade-guide-button"
        ],
        sectionID: SECTION_PRODUCTS,
        subsectionID: "upgrade-guide"
    },
    {
        patterns: [
            "upgrade-score-button"
        ],
        sectionID: SECTION_PRODUCTS,
        subsectionID: "upgrade-score"
    },
    {
        patterns: [
            "products-button-resources"
        ],
        sectionID: SECTION_PRODUCTS,
        subsectionID: "resources"
    },
    {
        patterns: [
            "navbar-account-button"
        ],
        sectionID: "account",
        subsectionID: ""
    },
    {
        patterns: [
            "navbar-account-manage"
        ],
        sectionID: "account",
        subsectionID: "manage"
    },
    {
        patterns: [
            "navbar-account-license"
        ],
        sectionID: "account",
        subsectionID: "license"
    },
    {
        patterns: [
            "navbar-account-logout-button"
        ],
        sectionID: "account",
        subsectionID: "sign-out"
    },
    {
        patterns: [
            "theme-mode-switch-trigger"
        ],
        sectionID: "mode-switch",
        subsectionID: ""
    },
    // mappings used in report buttons
    {
        patterns: [
            "science-behind-link"
        ],
        sectionID: "science-behind",
        subsectionID: null
    },
    {
        patterns: [
            "new-patient-button"
        ],
        sectionID: "new-patient",
        subsectionID: null
    },
    {
        patterns: [
            "consent-form-button"
        ],
        sectionID: "consent-form",
        subsectionID: null
    },
    {
        patterns: [
            "add-score-visit",
            "guide-to-score-link"
        ],
        sectionID: "add-visit",
        subsectionID: null
    }
];
function initReportLogging() {
    const loggableButtons = document.querySelectorAll("[class*='report-loggable-button']");
    loggableButtons.forEach((link)=>{
        link.addEventListener("click", clickLoggableReportButton);
    });
    const accordionButtons = document.querySelectorAll("[class*='meye-accordion']");
    accordionButtons.forEach((accordionButton)=>{
        accordionButton.addEventListener("click", clickMeyeAccordion);
    });
    const tooltipTriggers = document.querySelectorAll("[class*='tooltip-trigger']");
    tooltipTriggers.forEach((tooltipTrigger)=>{
        tooltipTrigger.addEventListener("mouseenter", hoverMeyeTooltip);
        tooltipTrigger.addEventListener("click", hoverMeyeTooltip);
    });
    const eyeToggles = document.querySelectorAll("[class*='eye-toggle-radio']");
    eyeToggles.forEach((eyeToggle)=>{
        eyeToggle.addEventListener("click", clickEyeToggle);
    });
    const visionSimulators = document.querySelectorAll("[class*='vision-sim-container']");
    visionSimulators.forEach((visionSimulator)=>{
        visionSimulator.addEventListener("click", clickVisionSimulator);
    });
}
function initContentLogging() {
    const contentCtas = document.querySelectorAll("[class^='content-cta']");
    contentCtas.forEach((contentCta)=>{
        contentCta.addEventListener("click", clickContentCta);
    });
    const contentQuestions = document.querySelectorAll("[class^='content-question-accordion']");
    contentQuestions.forEach((contentQuestion)=>{
        contentQuestion.addEventListener("click", clickContentQuestion);
    });
    const popupButtons = document.querySelectorAll("[class*='loggable-navigation-trigger']");
    popupButtons.forEach((popup)=>{
        popup.addEventListener("click", logNavigationTrigger);
    });
}
function logNavigationTrigger(event) {
    const element = event.currentTarget;
    const response = navigationSectionFromElement(element);
    if (response !== null) {
        if (response.section_id === "mode-switch") {
            const modeInfoElement = document.getElementById("theme-mode-switch-value");
            const mode = modeInfoElement.getAttribute("value");
            (0, _utilsJs.logEvent)("navigation", response.section_id, mode, "");
            return;
        }
        (0, _utilsJs.logEvent)("navigation", response.section_id, response.subsection_id, "");
    }
}
function getReportDetailsFromURL() {
    const currentUrl = new URL(window.location.href);
    const pathSegments = currentUrl.pathname.split("/");
    const reportFormatPath = pathSegments[LOGGING_CONFIG.REPORT_URL_INDICES.FORMAT];
    const reportFormat = REPORT_FORMAT_MAPPINGS[reportFormatPath] || LOGGING_CONFIG.DEFAULT_VALUES.REPORT_FORMAT;
    const reportID = pathSegments.length > LOGGING_CONFIG.REPORT_URL_INDICES.ID ? pathSegments[LOGGING_CONFIG.REPORT_URL_INDICES.ID] : LOGGING_CONFIG.DEFAULT_VALUES.REPORT_ID;
    const reportType = pathSegments.length > LOGGING_CONFIG.REPORT_URL_INDICES.TYPE ? pathSegments[LOGGING_CONFIG.REPORT_URL_INDICES.TYPE] : LOGGING_CONFIG.DEFAULT_VALUES.REPORT_TYPE;
    return [
        reportFormat,
        reportID,
        reportType
    ];
}
// THis is different to the loggable navigation trigger as this also needs to extract
// the report ID and type.
function clickLoggableReportButton(event) {
    const [reportFormat, reportID, reportType] = getReportDetailsFromURL();
    if (reportFormat !== null) {
        const sectionInfo = navigationSectionFromElement(event.currentTarget);
        let parameter = sectionInfo?.section_id || null;
        if (parameter !== null) parameter = parameterFromReportType(parameter, reportType);
        /* eslint-disable camelcase */ const details = {
            report_id: reportID,
            button_id: event.currentTarget.id
        };
        /* eslint-enable camelcase */ (0, _utilsJs.logEvent)("report", reportFormat, parameter, JSON.stringify(details));
    }
}
function parameterFromReportType(baseParameter, reportType) {
    let parameter = baseParameter;
    if (reportType === "ecp") parameter += LOGGING_CONFIG.PARAMETERS.ECP_SUFFIX;
    return parameter;
}
function clickVisionSimulator(event) {
    const [reportFormat, reportID, reportType] = getReportDetailsFromURL();
    if (reportFormat !== null) {
        const eventID = event.currentTarget.id;
        const parameter = parameterFromReportType(LOGGING_CONFIG.PARAMETERS.VISION_SIMULATOR, reportType);
        const details = parseReportDetails(reportID, eventID, event.currentTarget);
        if (details !== null) (0, _utilsJs.logEvent)("report", reportFormat, parameter, JSON.stringify(details));
    }
}
function hoverMeyeTooltip(event) {
    const [reportFormat, reportID, reportType] = getReportDetailsFromURL();
    if (reportFormat !== null) {
        const eventID = event.currentTarget.id;
        const parameter = parameterFromReportType(LOGGING_CONFIG.PARAMETERS.TOOLTIP, reportType);
        const details = parseReportDetails(reportID, eventID, event.currentTarget);
        if (details !== null) (0, _utilsJs.logEvent)("report", reportFormat, parameter, JSON.stringify(details));
    }
}
function clickMeyeAccordion(event) {
    const accordionButton = event.currentTarget;
    const [reportFormat, reportID, reportType] = getReportDetailsFromURL();
    let toggleValue = accordionButton.getAttribute("data-toggle");
    if (toggleValue !== null) {
        toggleValue = toggleValue === "collapse" ? "expand" : "collapse";
        accordionButton.setAttribute("data-toggle", toggleValue);
    }
    if (reportFormat !== null && (accordionButton.ariaExpanded === "true" || accordionButton.ariaSelected === "true" || toggleValue === "expand")) {
        const eventID = event.currentTarget.id;
        const parameter = parameterFromReportType(LOGGING_CONFIG.PARAMETERS.ACCORDION, reportType);
        const details = parseReportDetails(reportID, eventID, event.currentTarget);
        if (details !== null) (0, _utilsJs.logEvent)("report", reportFormat, parameter, JSON.stringify(details));
    }
}
function clickEyeToggle(event) {
    const toggleButton = event.currentTarget;
    const [reportFormat, reportID, reportType] = getReportDetailsFromURL();
    if (toggleButton.ariaSelected === "true" && reportFormat !== null) {
        const eventID = event.currentTarget.id;
        const parameter = parameterFromReportType(LOGGING_CONFIG.PARAMETERS.EYE_TOGGLE, reportType);
        const details = parseReportDetailsWithEye(reportID, eventID, event.currentTarget);
        if (details !== null) (0, _utilsJs.logEvent)("report", reportFormat, parameter, JSON.stringify(details));
    }
}
function clickContentCta(event) {
    const href = event.target.getAttribute("href");
    (0, _utilsJs.logEvent)(EVENT_TYPE_CONTENT, "click-cta", event.target.id, href);
}
function clickContentQuestion(event) {
    (0, _utilsJs.logEvent)(EVENT_TYPE_CONTENT, "expand-question", event.currentTarget.id, "");
}
function parseReportDetails(reportID, eventID, targetElement) {
    const response = sectionFromElementID(targetElement, false);
    if (response !== null) {
        // eslint-disable-next-line camelcase
        response.report_id = reportID;
        return response;
    }
    return null;
}
function parseReportDetailsWithEye(reportID, eventID, targetElement) {
    const response = sectionFromElementID(targetElement, true);
    if (response !== null) {
        // eslint-disable-next-line camelcase
        response.report_id = reportID;
        return response;
    }
    return null;
}
function parseEyeFromEventID(eventID) {
    if (eventID.includes("left")) return "left";
    else if (eventID.includes("right")) return "right";
    return null;
}
function sectionFromElementID(targetElement, parseEye) {
    const elementID = targetElement.id;
    for (const mapping of ELEMENT_ID_TO_SECTION_MAPPING)/* eslint-disable camelcase */ if (mapping.patterns.some((pattern)=>elementID.includes(pattern))) {
        const response = {
            section_id: mapping.sectionID,
            subsection_id: mapping.subsectionID,
            eye: null
        };
        if (mapping.parseEye || parseEye) response.eye = parseEyeFromEventID(elementID);
        if (mapping.subsectionSource !== undefined) response.subsection_id = targetElement.getAttribute(mapping.subsectionSource);
        return response;
    }
    return null;
}
function navigationSectionFromElement(targetElement) {
    const elementID = targetElement.id;
    for (const mapping of NAVIGATION_ID_TO_SECTION_MAPPING)/* eslint-disable camelcase */ if (mapping.patterns.some((pattern)=>elementID.includes(pattern))) {
        const response = {
            section_id: mapping.sectionID,
            subsection_id: mapping.subsectionID
        };
        if (mapping.subsectionSource !== undefined) response.subsection_id = targetElement.getAttribute(mapping.subsectionSource);
        return response;
    }
    return null;
}

},{"./utils.js":"1ZMQB","@parcel/transformer-js/src/esmodule-helpers.js":"iM2Jf"}],"1ZMQB":[function(require,module,exports,__globalThis) {
/* eslint-disable camelcase */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "browser", ()=>browser);
/**
 * Swap between two classes.
 * @param {HTMLElement} element
 * @param {string} newClass
 * @param {string} oldClass
 * @param {boolean} condition
 */ parcelHelpers.export(exports, "swapClasses", ()=>swapClasses);
/**
 * Round number to the nearest .25
 */ parcelHelpers.export(exports, "roundIntToQuarter", ()=>roundIntToQuarter);
/**
 * Round a given number to the nearest step value;
 * @param {number} number
 * @param {number} step
 * @returns {number}
 */ parcelHelpers.export(exports, "roundToNearest", ()=>roundToNearest);
/**
 * Check if current browser is Safari
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isSafari", ()=>isSafari);
/**
 * Swap classes according to the given condition.
 * @param {boolean} condition
 * @param {HTMLElement} element
 * @param {string} class1
 * @param {string} class2
 */ parcelHelpers.export(exports, "swapClassesIf", ()=>swapClassesIf);
/**
 * Restrict a value between a minimum and maximum range.
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @returns number
 */ parcelHelpers.export(exports, "valueInRange", ()=>valueInRange);
/**
 * Run element callback once if initCondition is true and add listener.
 *
 * @param {HTMLElement} element
 * @param {boolean} initCondition
 * @param {string} eventName
 * @param {(HTMLElement) => any} callback
 */ parcelHelpers.export(exports, "initThenListen", ()=>initThenListen);
/**
 *
 * @param {HTMLInputElement} input
 * @param {any} value
 */ parcelHelpers.export(exports, "setInputValue", ()=>setInputValue);
/**
 * Animate numeric progression.
 * @param {string} idDiv
 * @param {number} initVal
 * @param {number} lastVal
 * @param {number} duration
 */ parcelHelpers.export(exports, "animateNumericProgression", ()=>animateNumericProgression);
/** Uppercase first letter of string;
 * @param {string} str
 * @returns {string}
 */ parcelHelpers.export(exports, "upperCaseFirstLetter", ()=>upperCaseFirstLetter);
/**
 * Lowercase first letter of string;
 * @param {string} str
 * @returns {string}
 */ parcelHelpers.export(exports, "lowerCaseFirstLetter", ()=>lowerCaseFirstLetter);
/**
 * Remove substring from string;
 * @param {string} str
 * @returns {string}
 */ parcelHelpers.export(exports, "cut", ()=>cut);
/**
 * Reduce Object.entries() with the given condition.
 * @param {object} obj
 * @param {(key: string, value: any) => boolean} conditionFunction
 * @returns {object}
 */ parcelHelpers.export(exports, "reduceEntries", ()=>reduceEntries);
/**
 *
 * @param {HTMLElement} container
 * @returns {NodeListOf<HTMLInputElement>}
 */ parcelHelpers.export(exports, "getInputs", ()=>getInputs);
/**
 * Check if the viewport width is within the deskop breakpoint.
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isDesktopBreakpoint", ()=>isDesktopBreakpoint);
/**
 *
 * @param {string} str
 * @returns {string}
 */ parcelHelpers.export(exports, "kebabToCamelCase", ()=>kebabToCamelCase);
/**
 * @param {*} str
 * @returns {string}
 */ parcelHelpers.export(exports, "camelToKebabCase", ()=>camelToKebabCase);
/**
 *
 * @param {string} str
 * @returns {string}
 */ parcelHelpers.export(exports, "snakeToCamelCase", ()=>snakeToCamelCase);
/**
 * Validate if value is in the right range.
 * @param {number} value
 * @param {number} min
 * @param {number} max
 * @returns {boolean}
 */ parcelHelpers.export(exports, "validRange", ()=>validRange);
/**
 * Formats date into ISO string pattern.
 * @param {Date} date
 */ parcelHelpers.export(exports, "formatISODate", ()=>formatISODate);
/**
 * Gets a format pattern and apply it to a value accordingly.
 * @param {string} format
 * @param {number|string} value
 * @returns {[number|string, string]}
 */ parcelHelpers.export(exports, "parseFormat", ()=>parseFormat);
/**
 * @param {string} str
 * @param {string} pattern
 * @returns {boolean}
 */ parcelHelpers.export(exports, "like", ()=>like);
/**
 * Format date to dd/mm/YYYY format.
 * @param {string} inputDate
 * @returns {string}
 */ parcelHelpers.export(exports, "formatDate", ()=>formatDate);
/**
 * Format Date object to string yyyy-mm-dd.
 * @param {Date} date
 * @returns {string}
 */ parcelHelpers.export(exports, "formatDateToYMD", ()=>formatDateToYMD);
/**
 * Format dd/mm/yyyy to yyyy/mm/dd.
 * @param {string} dateStr
 * @returns {string}
 */ parcelHelpers.export(exports, "formatStringToYMD", ()=>formatStringToYMD);
/*
 * Check if user agent is a mobile device.
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isMobileUserAgent", ()=>isMobileUserAgent);
/**
 * Converts a string input into a boolean
 * value based on a list of valid options.
 * @returns {boolean}
 */ parcelHelpers.export(exports, "stringToBoolean", ()=>stringToBoolean);
/**
 * Checks if all values in an array are non-empty values.
 * @param {any[]} values
 * @returns {boolean}
 */ parcelHelpers.export(exports, "areAllValuesPresent", ()=>areAllValuesPresent);
/**
 * Calculates the absolute time difference
 * between two dates in years.
 * @param {Date} date1
 * @param {Date} date2
 * @returns {float}
 */ parcelHelpers.export(exports, "calculateYearDifference", ()=>calculateYearDifference);
/**
 * Checks if there are some dates where the time difference in years
 * between them are lower than the given limit.
 * @param {string[]} dates
 * @param {float} limit
 * @returns {boolean}
 */ parcelHelpers.export(exports, "areDatesBelowLimit", ()=>areDatesBelowLimit);
/**
 * Check if value is empty.
 * @param {*} value
 */ parcelHelpers.export(exports, "empty", ()=>empty);
/**
 * Check if element object is a form.
 * @param {HTMLElement} elementObject
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isForm", ()=>isForm);
/**
 * Strips name to only retain first name
 */ parcelHelpers.export(exports, "stripNameInput", ()=>stripNameInput);
/**
 * Checks if a string is a number.
 * @param {string} value
 * @returns {boolean}
 */ parcelHelpers.export(exports, "isNumericString", ()=>isNumericString);
/**
 * Strip trailing numbers from a string based on a given
 * pattern.
 * @param {string} value
 * @param {RegExp} pattern
 * @returns
 */ parcelHelpers.export(exports, "stripTrailingNumbers", ()=>stripTrailingNumbers);
/*
 * Submits a validation error for a form
 * @param form
 * @param {string} formType
 */ parcelHelpers.export(exports, "submitFormValidationError", ()=>submitFormValidationError);
/*
 * Submits a validation error for a form
 * @param form
 * @param {string} formType
 */ parcelHelpers.export(exports, "submitFormError", ()=>submitFormError);
parcelHelpers.export(exports, "logShareEvent", ()=>logShareEvent);
parcelHelpers.export(exports, "logEvent", ()=>logEvent);
/**
 * Formats the submission and extracts a CSRF Token
 * @param {FormData} formData
 */ parcelHelpers.export(exports, "formatFormErrorSubmission", ()=>formatFormErrorSubmission);
parcelHelpers.export(exports, "setCookie", ()=>setCookie);
parcelHelpers.export(exports, "getCookie", ()=>getCookie);
/**
 * Checks if the current page is either the login page or the register page.
 *
 * @returns {boolean} true if the current page is the login or register page, otherwise false.
 */ parcelHelpers.export(exports, "isLoginOrRegisterPage", ()=>isLoginOrRegisterPage);
/**
 * Determines the platform type of the user's browser device.
 *
 * @returns {string} The platform type of the device (e.g., "desktop", "mobile", "tablet").
 */ parcelHelpers.export(exports, "getBrowserDevice", ()=>getBrowserDevice);
/**
 * Checks if the user's browser satisfies the specified version requirements
 * or if the device is a tablet.
 *
 * @returns {boolean} - Returns `true` if the browser meets the version requirements
 *                      or the device is identified as a tablet; otherwise, `false`.
 */ parcelHelpers.export(exports, "isValidBrowser", ()=>isValidBrowser);
/**
 * Reindex an attribute with the given index number.
 * @param {string} attr
 * @param {number} index
 * @returns {string}
 */ parcelHelpers.export(exports, "reIndexAttribute", ()=>reIndexAttribute);
/**
 * @param {any[]} messages
 * @param {HTMLElement} error
 */ parcelHelpers.export(exports, "updateMessages", ()=>updateMessages);
parcelHelpers.export(exports, "updateHighlighting", ()=>updateHighlighting);
/**
 * @param {any[]} messages
 * @param {HTMLInputElement} input
 * @param {HTMLElement} error
 */ parcelHelpers.export(exports, "updateErrors", ()=>updateErrors);
/*
 * Position an absolute element at the bottom of a given target rect element.
 * @param {HTMLElement} element
 * @param {DOMRect} targetRect
 * @param {number} offset
 */ parcelHelpers.export(exports, "positionAtBottom", ()=>positionAtBottom);
/**
 * Position an absolute element in the center of a given target rect element.
 * @param {HTMLElement} element
 * @param {DOMRect} targetRect
 * @param {number} offset
 */ parcelHelpers.export(exports, "positionInCenter", ()=>positionInCenter);
parcelHelpers.export(exports, "arraysAreEqual", ()=>arraysAreEqual);
/**
 * Converts an array path to a dot-separated string.
 * @param {string[]} pathArray
 * @returns {string}
 */ parcelHelpers.export(exports, "arrayPathToString", ()=>arrayPathToString);
/**
 * Converts an dot-separated string path to array.
 * @param {string} pathString
 * @returns {string[]}
 */ parcelHelpers.export(exports, "stringPathToArray", ()=>stringPathToArray);
/**
 * Generate a new object from a form data instance.
 * @param {FormData} formData
 * @returns {object}
 */ parcelHelpers.export(exports, "formDataToObject", ()=>formDataToObject);
/**
 * Transform field keys into js notation.
 * @param {*} dataObject
 */ parcelHelpers.export(exports, "demographicDataTransformer", ()=>demographicDataTransformer);
/**
 * Get element by id or instance.
 * @param {string | HTMLElement} idOrElement
 * @return {HTMLElement | null}
 */ parcelHelpers.export(exports, "getElementByIdOrInstance", ()=>getElementByIdOrInstance);
/**
 * Return a string with the first letter capitalized
 * @param {string} str
 * @returns {string}
 */ parcelHelpers.export(exports, "capitalize", ()=>capitalize);
/**
 * Escape a value for safe interpolation into HTML text or a double-quoted attribute.
 * The ampersand is replaced first so the entities emitted below are not re-escaped.
 * @param {unknown} value
 * @returns {string}
 */ parcelHelpers.export(exports, "escapeHtml", ()=>escapeHtml);
var _bowser = require("bowser");
var _bowserDefault = parcelHelpers.interopDefault(_bowser);
var _constants = require("./constants");
const browser = (0, _bowserDefault.default).getParser(window.navigator.userAgent);
function swapClasses(element, newClass, oldClass) {
    element.classList.add(newClass);
    element.classList.remove(oldClass);
}
function roundIntToQuarter(number) {
    return (Math.round(number * 4) / 4).toFixed(2);
}
function roundToNearest(number, step) {
    return Math.round(number / step) * step;
}
function isSafari() {
    const { userAgent } = navigator;
    return userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") < 0 && userAgent.indexOf("Firefox") < 0 && userAgent.indexOf("Chrome") < 0;
}
function swapClassesIf(condition, element, class1, class2) {
    if (condition) swapClasses(element, class1, class2);
    else swapClasses(element, class2, class1);
}
function valueInRange(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function initThenListen(element, initCondition, eventName, callback) {
    if (initCondition) callback(element);
    element.addEventListener(eventName, ()=>callback(element));
}
function setInputValue(input, value) {
    input.value = value;
    input.setAttribute("value", value);
}
function animateNumericProgression(idDiv, initVal, lastVal, duration) {
    const obj = document.getElementById(idDiv);
    let calculatedValue;
    let startTime = null;
    function step(currentTime) {
        if (!startTime) startTime = currentTime;
        // calculate the value to be used in calculating the number to be displayed
        const progress = Math.min((currentTime - startTime) / duration, 1);
        // calculate what to be displayed using the value above
        calculatedValue = Math.floor(progress * (lastVal - initVal) + initVal);
        obj.innerText = calculatedValue.toLocaleString();
        // checking to make sure the counter does not exceed the last value(lastVal)
        if (progress < 1) window.requestAnimationFrame(step);
        else window.cancelAnimationFrame(window.requestAnimationFrame(step));
    }
    // start animating
    window.requestAnimationFrame(step);
}
function upperCaseFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
function lowerCaseFirstLetter(str) {
    return str.charAt(0).toLowerCase() + str.slice(1);
}
function cut(str, strToRemove) {
    return str.replace(strToRemove, "");
}
function reduceEntries(obj, conditionFunction) {
    return Object.entries(obj).reduce((prev, [key, value])=>{
        if (conditionFunction(key, value)) prev[key] = value;
        return prev;
    }, {});
}
function getInputs(container) {
    return container.querySelectorAll("input,select");
}
function isDesktopBreakpoint() {
    return document.documentElement.clientWidth >= 1024;
}
function kebabToCamelCase(str) {
    return lowerCaseFirstLetter(str.split("-").map((piece)=>upperCaseFirstLetter(piece)).join(""));
}
function camelToKebabCase(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function snakeToCamelCase(str) {
    return lowerCaseFirstLetter(str.split("_").map((piece)=>upperCaseFirstLetter(piece)).join(""));
}
function validRange(value, min, max) {
    return value >= min && value <= max;
}
function formatISODate(date) {
    return date.toISOString().slice(0, 10);
}
function parseFormat(format, value, nan = false) {
    const _value = value ? parseFloat(value).toFixed(2) : value;
    if (nan && isNaN(_value)) return value;
    switch(format){
        case "0.00D":
            return [
                _value,
                "D"
            ];
        case "0.00mm":
            return [
                _value,
                "mm"
            ];
        case "0":
        default:
            return [
                value,
                ""
            ];
    }
}
function like(str, pattern) {
    const escapedPattern = pattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp("^" + `.*${escapedPattern}.*` + "$", "i");
    return regex.test(str);
}
function formatDate(inputDate) {
    const date = new Date(inputDate);
    return new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
    }).format(date);
}
function formatDateToYMD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}
function formatStringToYMD(dateStr) {
    const [day, month, year] = dateStr.split("/");
    return `${year}-${month}-${day}`;
}
function isMobileUserAgent() {
    return !(navigator.userAgent.indexOf("Mobile") <= 0);
}
function stringToBoolean(input, validOptions = [
    "true",
    "false"
]) {
    if (typeof input !== "string") return false;
    const inputLower = input.trim().toLowerCase();
    if (!validOptions.includes(inputLower)) return false;
    return inputLower === "true";
}
function areAllValuesPresent(values) {
    return values.every((value)=>!!value || value === 0);
}
function calculateYearDifference(date1, date2) {
    let diff = (date1.getTime() - date2.getTime()) / 1000;
    diff /= 86400;
    return Math.abs(diff / 365.25);
}
function areDatesBelowLimit(dates, limit) {
    const sortedDates = [
        ...dates
    ].sort((a, b)=>new Date(a) - new Date(b));
    for(let i = 0; i < sortedDates.length - 1; i++){
        const first = new Date(sortedDates[i]);
        const second = new Date(sortedDates[i + 1]);
        if (calculateYearDifference(first, second) < limit) return true;
    }
    return false;
}
function empty(value) {
    return value == null || value === "";
}
function isForm(elementObject) {
    return elementObject instanceof HTMLFormElement;
}
function stripNameInput() {
    const nameFields = document.querySelectorAll("input[name='name']");
    if (!nameFields.length) return;
    nameFields.forEach((field)=>{
        if (field.dataset.allowFullName === "true") return;
        const [firstName] = field.value.split(" ");
        field.value = firstName;
    });
}
function isNumericString(value) {
    return !isNaN(Number(value));
}
function stripTrailingNumbers(value, pattern = /-\d+$/) {
    if (pattern.test(value)) return value.replace(pattern, "");
    return value;
}
function submitFormValidationError(form, formType) {
    submitFormError(form, formType, null);
}
function submitFormError(form, formType, subType) {
    const formData = new FormData(form);
    const { formJSON, csrfToken } = formatFormErrorSubmission(formData);
    let url = "/api/integration/log_error/report/" + formType;
    if (subType) url += "/" + subType;
    fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken
        },
        body: JSON.stringify(formJSON)
    }).then((response)=>{
        if (!response.ok) console.error("Failed to log error:", response.statusText);
    }).catch((error)=>{
        console.error("Error while posting validation failure:", error);
    });
}
function logShareEvent(eventSubtype) {
    const qrUrl = document.getElementById("sharing-options-list")?.getAttribute("data-qr-url") || "";
    const csrfToken = document.getElementById("sharing-options")?.getAttribute("data-csrf-token") || "";
    const fullUrl = window.location.href;
    const urlObj = new URL(qrUrl, window.location.origin);
    const pathParts = urlObj.pathname.split("/");
    const fullUrlParts = fullUrl.split("/");
    const reportPath = pathParts[1] ?? null;
    const shortId = pathParts[2] ?? null;
    const lastPart = fullUrlParts[fullUrlParts.length - 1];
    const isEcp = lastPart.includes("ecp");
    const fullSubType = "share-" + (isEcp ? "ecp" : "parent") + "-" + eventSubtype;
    let toolSlug = "meye-gauge";
    if (reportPath === "qr-meye") toolSlug = "meye-guide";
    else if (reportPath === "qr-score") toolSlug = "meye-score";
    const payload = {
        event_type: "report",
        event_subtype: toolSlug,
        parameter: fullSubType,
        short_id: shortId,
        tool_slug: toolSlug
    };
    // Gauge has no pathname (no short_id or ecp identifier), so we don't need to add it
    if (toolSlug !== "meye-gauge") payload.details = shortId;
    fetch("/api/integration/log_share_event", {
        method: "POST",
        headers: {
            "X-CSRFToken": csrfToken,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
    }).catch(console.error);
}
function logEvent(eventType, eventSubtype, parameter, details) {
    const csrfToken = document.getElementById("logging-csrf-token")?.getAttribute("data-token") || "";
    const payload = {
        event_type: eventType,
        event_subtype: eventSubtype,
        parameter: parameter,
        details: details
    };
    fetch("/api/integration/log_share_event", {
        method: "POST",
        headers: {
            "X-CSRFToken": csrfToken,
            "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
    }).catch(console.error);
}
function formatFormErrorSubmission(formData) {
    const formJSON = {};
    let csrfToken = document.querySelector("input[name='csrf_token']")?.value || "";
    const doNotSend = [
        "name",
        "dob_date",
        "password",
        "confirm",
        "password_1",
        "password_2",
        "current_password"
    ];
    formData.forEach((value, key)=>{
        if (key === "csrf_token") csrfToken = value;
        else if (doNotSend.includes(key)) formJSON[key] = value ? "Set" : "Not set";
        else formJSON[key] = value;
    });
    return {
        formJSON,
        csrfToken
    };
}
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 86400000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (const element of ca){
        const c = element.trim();
        if (c.startsWith(nameEQ)) return c.substring(nameEQ.length);
    }
    return null;
}
function isLoginOrRegisterPage() {
    const loginPage = document.getElementById("login-page");
    const registerPage = document.getElementById("register-page");
    return !!loginPage || !!registerPage;
}
function getBrowserDevice() {
    return browser.getPlatformType();
}
function isValidBrowser() {
    const isValid = browser.satisfies((0, _constants.SUPPORTED_BROWSERS_BOWSER_CONFIG));
    return isValid === true || getBrowserDevice() === "tablet";
}
function reIndexAttribute(attr, index) {
    const regexEndsWithNumber = /\d+$/;
    if (regexEndsWithNumber.test(attr)) return attr.replace(regexEndsWithNumber, index);
    return `${attr}-${index}`;
}
function updateMessages(messages, error) {
    if (!error) return;
    if (messages.length) {
        const emailMessage = messages.map((m)=>m.message).join(", ");
        error.innerText = emailMessage;
        error.classList.remove("invisible");
    } else {
        error.innerText = ".";
        error.classList.add("invisible");
    }
}
function updateHighlighting(active, element) {
    if (!element) return;
    const errorSelector = element.closest(element.dataset?.errorSelector) ?? element;
    const errorClass = element.dataset?.errorClass ?? "error";
    if (active) errorSelector?.classList?.add(errorClass);
    else errorSelector?.classList?.remove(errorClass);
}
function updateErrors(messages, input, error) {
    if (input) {
        const errorSelector = input.closest(input.dataset?.errorSelector) ?? input;
        const errorClass = input.dataset?.errorClass ?? "error";
        if (messages.length) errorSelector?.classList?.add(errorClass);
        else errorSelector?.classList?.remove(errorClass);
    }
    if (error) {
        if (messages.length) {
            const emailMessage = messages[0].message;
            error.innerText = emailMessage;
            error.classList.remove("invisible");
        } else {
            error.innerText = ".";
            error.classList.add("invisible");
        }
    }
}
function positionAtBottom(element, targetRect, offset = 0) {
    const topPosition = targetRect.height;
    element.style.top = `${topPosition - offset}px`;
}
function positionInCenter(element, targetRect, offset = 0) {
    const middle = targetRect.height / 2;
    const absoluteHeight = element.offsetHeight;
    element.style.top = `${middle - absoluteHeight / 2 - offset}px`;
}
function arraysAreEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    return arr1.every((element, index)=>element === arr2[index]);
}
function arrayPathToString(pathArray) {
    return pathArray.join(".");
}
function stringPathToArray(pathString) {
    return pathString.split(".").map((part)=>{
        if (/^\d+$/.test(part)) return Number(part);
        return part;
    });
}
function formDataToObject(formData) {
    const result = {};
    formData.forEach(function(value, key) {
        const trimmedValue = value?.trim();
        result[key] = empty(trimmedValue) ? undefined : trimmedValue;
    });
    return result;
}
function demographicDataTransformer(dataObject) {
    return {
        name: dataObject["name"],
        patientId: dataObject["patient_id"],
        visitDate: dataObject["visit_date"],
        linkSphereOD: dataObject["right_eye-sphere_linked"],
        sphereOD: dataObject["right_eye-sphere"],
        linkCylinderOD: dataObject["right_eye-cylinder_linked"],
        cylinderOD: dataObject["right_eye-cylinder"],
        linkAxisOD: dataObject["right_eye-axis_linked"],
        axisOD: dataObject["right_eye-axis"],
        linkSphereOS: dataObject["left_eye-sphere_linked"],
        sphereOS: dataObject["left_eye-sphere"],
        linkCylinderOS: dataObject["left_eye-cylinder_linked"],
        cylinderOS: dataObject["left_eye-cylinder"],
        linkAxisOS: dataObject["left_eye-axis_linked"],
        axisOS: dataObject["left_eye-axis"],
        linkMeasuredAxialLengthOD: dataObject["right_eye-length_linked"],
        measuredAxialLengthOD: dataObject["right_eye-length"],
        linkMeasuredAxialLengthOS: dataObject["left_eye-length_linked"],
        measuredAxialLengthOS: dataObject["left_eye-length"],
        linkK1OD: dataObject["right_eye-k1_linked"],
        k1OD: dataObject["right_eye-k1"],
        linkR1OD: dataObject["right_eye-r1_linked"],
        r1OD: dataObject["right_eye-r1"],
        linkK2OD: dataObject["right_eye-k2_linked"],
        k2OD: dataObject["right_eye-k2"],
        linkR2OD: dataObject["right_eye-r2_linked"],
        r2OD: dataObject["right_eye-r2"],
        linkK1OS: dataObject["left_eye-k1_linked"],
        k1OS: dataObject["left_eye-k1"],
        linkR1OS: dataObject["left_eye-r1_linked"],
        r1OS: dataObject["left_eye-r1"],
        linkK2OS: dataObject["left_eye-k2_linked"],
        k2OS: dataObject["left_eye-k2"],
        linkR2OS: dataObject["left_eye-r2_linked"],
        r2OS: dataObject["left_eye-r2"]
    };
}
function getElementByIdOrInstance(idOrElement) {
    if (typeof idOrElement === "string") return document.getElementById(idOrElement);
    else if (idOrElement instanceof HTMLElement) return idOrElement;
    return null;
}
function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
function escapeHtml(value) {
    return String(value ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}

},{"bowser":"9oobr","./constants":"46Exw","@parcel/transformer-js/src/esmodule-helpers.js":"iM2Jf"}],"9oobr":[function(require,module,exports,__globalThis) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    return function(e) {
        var t = {};
        function r(i) {
            if (t[i]) return t[i].exports;
            var n = t[i] = {
                i: i,
                l: !1,
                exports: {}
            };
            return e[i].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, i) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: i
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var i = Object.create(null);
            if (r.r(i), Object.defineProperty(i, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var n in e)r.d(i, n, (function(t) {
                return e[t];
            }).bind(null, n));
            return i;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i = r(18), n = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    t.push(0);
                    var r = t[0], i = t[1];
                    if (10 === r) switch(i){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                    switch(r){
                        case 11:
                            return "Big Sur";
                        case 12:
                            return "Monterey";
                        case 13:
                            return "Ventura";
                        case 14:
                            return "Sonoma";
                        case 15:
                            return "Sequoia";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, i) {
                    void 0 === i && (i = !1);
                    var n = e.getVersionPrecision(t), a = e.getVersionPrecision(r), o = Math.max(n, a), s = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = o - e.getVersionPrecision(t), i = t + new Array(r + 1).join(".0");
                        return e.map(i.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(i && (s = o - Math.min(n, a)), o -= 1; o >= s;){
                        if (u[0][o] > u[1][o]) return 1;
                        if (u[0][o] === u[1][o]) {
                            if (o === s) return 0;
                            o -= 1;
                        } else if (u[0][o] < u[1][o]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, i = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)i.push(t(e[r]));
                    return i;
                }, e.find = function(e, t) {
                    var r, i;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, i = e.length; r < i; r += 1){
                        var n = e[r];
                        if (t(n, r)) return n;
                    }
                }, e.assign = function(e) {
                    for(var t, r, i = e, n = arguments.length, a = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)a[o - 1] = arguments[o];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(a));
                    var s = function() {
                        var e = a[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            i[t] = e[t];
                        });
                    };
                    for(t = 0, r = a.length; t < r; t += 1)s();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return i.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return i.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = n, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                AmazonBot: "amazonbot",
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                BaiduSpider: "baiduspider",
                Bada: "bada",
                BingCrawler: "bingcrawler",
                Brave: "brave",
                BlackBerry: "blackberry",
                "ChatGPT-User": "chatgpt_user",
                Chrome: "chrome",
                ClaudeBot: "claudebot",
                Chromium: "chromium",
                Diffbot: "diffbot",
                DuckDuckBot: "duckduckbot",
                DuckDuckGo: "duckduckgo",
                Electron: "electron",
                Epiphany: "epiphany",
                FacebookExternalHit: "facebookexternalhit",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                GPTBot: "gptbot",
                "Internet Explorer": "ie",
                InternetArchiveCrawler: "internetarchivecrawler",
                "K-Meleon": "k_meleon",
                LibreWolf: "librewolf",
                Linespider: "linespider",
                Maxthon: "maxthon",
                "Meta-ExternalAds": "meta_externalads",
                "Meta-ExternalAgent": "meta_externalagent",
                "Meta-ExternalFetcher": "meta_externalfetcher",
                "Meta-WebIndexer": "meta_webindexer",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                "OAI-SearchBot": "oai_searchbot",
                Omgilibot: "omgilibot",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                "Pale Moon": "pale_moon",
                PerplexityBot: "perplexitybot",
                "Perplexity-User": "perplexity_user",
                PhantomJS: "phantomjs",
                PingdomBot: "pingdombot",
                Puffin: "puffin",
                QQ: "qq",
                QQLite: "qqlite",
                QupZilla: "qupzilla",
                Roku: "roku",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SlackBot: "slackbot",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                "Sogou Browser": "sogou",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                YahooSlurp: "yahooslurp",
                "Yandex Browser": "yandex",
                YandexBot: "yandexbot",
                YouBot: "youbot"
            };
            t.BROWSER_MAP = {
                amazonbot: "AmazonBot",
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                baiduspider: "BaiduSpider",
                bada: "Bada",
                bingcrawler: "BingCrawler",
                blackberry: "BlackBerry",
                brave: "Brave",
                chatgpt_user: "ChatGPT-User",
                chrome: "Chrome",
                claudebot: "ClaudeBot",
                chromium: "Chromium",
                diffbot: "Diffbot",
                duckduckbot: "DuckDuckBot",
                duckduckgo: "DuckDuckGo",
                edge: "Microsoft Edge",
                electron: "Electron",
                epiphany: "Epiphany",
                facebookexternalhit: "FacebookExternalHit",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                google_search: "Google Search",
                googlebot: "Googlebot",
                gptbot: "GPTBot",
                ie: "Internet Explorer",
                internetarchivecrawler: "InternetArchiveCrawler",
                k_meleon: "K-Meleon",
                librewolf: "LibreWolf",
                linespider: "Linespider",
                maxthon: "Maxthon",
                meta_externalads: "Meta-ExternalAds",
                meta_externalagent: "Meta-ExternalAgent",
                meta_externalfetcher: "Meta-ExternalFetcher",
                meta_webindexer: "Meta-WebIndexer",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                oai_searchbot: "OAI-SearchBot",
                omgilibot: "Omgilibot",
                opera: "Opera",
                opera_coast: "Opera Coast",
                pale_moon: "Pale Moon",
                perplexitybot: "PerplexityBot",
                perplexity_user: "Perplexity-User",
                phantomjs: "PhantomJS",
                pingdombot: "PingdomBot",
                puffin: "Puffin",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                qupzilla: "QupZilla",
                roku: "Roku",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                slackbot: "SlackBot",
                sleipnir: "Sleipnir",
                sogou: "Sogou Browser",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yahooslurp: "YahooSlurp",
                yandex: "Yandex Browser",
                yandexbot: "YandexBot",
                youbot: "YouBot"
            };
            t.PLATFORMS_MAP = {
                bot: "bot",
                desktop: "desktop",
                mobile: "mobile",
                tablet: "tablet",
                tv: "tv"
            };
            t.OS_MAP = {
                Android: "Android",
                Bada: "Bada",
                BlackBerry: "BlackBerry",
                ChromeOS: "Chrome OS",
                HarmonyOS: "HarmonyOS",
                iOS: "iOS",
                Linux: "Linux",
                MacOS: "macOS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku",
                Tizen: "Tizen",
                WebOS: "WebOS",
                Windows: "Windows",
                WindowsPhone: "Windows Phone"
            };
            t.ENGINE_MAP = {
                Blink: "Blink",
                EdgeHTML: "EdgeHTML",
                Gecko: "Gecko",
                Presto: "Presto",
                Trident: "Trident",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(91)) && i.__esModule ? i : {
                default: i
            }, a = r(18);
            function o(e, t) {
                for(var r = 0; r < t.length; r++){
                    var i = t[r];
                    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i);
                }
            }
            var s = function() {
                function e() {}
                var t, r, i;
                return e.getParser = function(e, t, r) {
                    if (void 0 === t && (t = !1), void 0 === r && (r = null), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new n.default(e, t, r);
                }, e.parse = function(e, t) {
                    return void 0 === t && (t = null), new n.default(e, t).getResult();
                }, t = e, i = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return a.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return a.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return a.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return a.PLATFORMS_MAP;
                        }
                    }
                ], r = null, i && o(t, i), e;
            }();
            t.default = s, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i = u(r(92)), n = u(r(93)), a = u(r(94)), o = u(r(95)), s = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t, r) {
                    if (void 0 === t && (t = !1), void 0 === r && (r = null), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e;
                    var i = !1;
                    "boolean" == typeof t ? (i = t, this._hints = r) : this._hints = null != t && "object" == typeof t ? t : null, this.parsedResult = {}, !0 !== i && this.parse();
                }
                var t = e.prototype;
                return t.getHints = function() {
                    return this._hints;
                }, t.hasBrand = function(e) {
                    if (!this._hints || !Array.isArray(this._hints.brands)) return !1;
                    var t = e.toLowerCase();
                    return this._hints.brands.some(function(e) {
                        return e.brand && e.brand.toLowerCase() === t;
                    });
                }, t.getBrandVersion = function(e) {
                    if (this._hints && Array.isArray(this._hints.brands)) {
                        var t = e.toLowerCase(), r = this._hints.brands.find(function(e) {
                            return e.brand && e.brand.toLowerCase() === t;
                        });
                        return r ? r.version : void 0;
                    }
                }, t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = s.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA(), this)), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = s.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = s.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = s.default.find(o.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (Array.isArray(t.test)) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return s.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, i = 0, n = {}, a = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var o = e[t];
                        "string" == typeof o ? (n[t] = o, a += 1) : "object" == typeof o && (r[t] = o, i += 1);
                    }), i > 0) {
                        var o = Object.keys(r), u = s.default.find(o, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = s.default.find(o, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (a > 0) {
                        var l = Object.keys(n), b = s.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== b) return this.compareVersion(n[b]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), i = e.toLowerCase(), n = s.default.getBrowserTypeByAlias(i);
                    return t && n && (i = n.toLowerCase()), i === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, i = !1, n = this.getBrowserVersion();
                    if ("string" == typeof n) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (i = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (i = !0, r = e.substr(1)), t.indexOf(s.default.compareVersions(n, r, i)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            };
            var a = /version\/(\d+(\.?_?\d+)+)/i, o = [
                {
                    test: [
                        /gptbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "GPTBot"
                        }, r = n.default.getFirstMatch(/gptbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chatgpt-user/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "ChatGPT-User"
                        }, r = n.default.getFirstMatch(/chatgpt-user\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /oai-searchbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "OAI-SearchBot"
                        }, r = n.default.getFirstMatch(/oai-searchbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /claudebot/i,
                        /claude-web/i,
                        /claude-user/i,
                        /claude-searchbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "ClaudeBot"
                        }, r = n.default.getFirstMatch(/(?:claudebot|claude-web|claude-user|claude-searchbot)\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /omgilibot/i,
                        /webzio-extended/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Omgilibot"
                        }, r = n.default.getFirstMatch(/(?:omgilibot|webzio-extended)\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /diffbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Diffbot"
                        }, r = n.default.getFirstMatch(/diffbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /perplexitybot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PerplexityBot"
                        }, r = n.default.getFirstMatch(/perplexitybot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /perplexity-user/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Perplexity-User"
                        }, r = n.default.getFirstMatch(/perplexity-user\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /youbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "YouBot"
                        }, r = n.default.getFirstMatch(/youbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /meta-webindexer/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Meta-WebIndexer"
                        }, r = n.default.getFirstMatch(/meta-webindexer\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /meta-externalads/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Meta-ExternalAds"
                        }, r = n.default.getFirstMatch(/meta-externalads\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /meta-externalagent/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Meta-ExternalAgent"
                        }, r = n.default.getFirstMatch(/meta-externalagent\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /meta-externalfetcher/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Meta-ExternalFetcher"
                        }, r = n.default.getFirstMatch(/meta-externalfetcher\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = n.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /linespider/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Linespider"
                        }, r = n.default.getFirstMatch(/(?:linespider)(?:-[-\w]+)?[\s/](\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /amazonbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "AmazonBot"
                        }, r = n.default.getFirstMatch(/amazonbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bingbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BingCrawler"
                        }, r = n.default.getFirstMatch(/bingbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /baiduspider/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BaiduSpider"
                        }, r = n.default.getFirstMatch(/baiduspider\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /duckduckbot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "DuckDuckBot"
                        }, r = n.default.getFirstMatch(/duckduckbot\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ia_archiver/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "InternetArchiveCrawler"
                        }, r = n.default.getFirstMatch(/ia_archiver\/(\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /facebookexternalhit/i,
                        /facebookcatalog/i
                    ],
                    describe: function() {
                        return {
                            name: "FacebookExternalHit"
                        };
                    }
                },
                {
                    test: [
                        /slackbot/i,
                        /slack-imgProxy/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlackBot"
                        }, r = n.default.getFirstMatch(/(?:slackbot|slack-imgproxy)(?:-[-\w]+)?[\s/](\d+(\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yahoo!?[\s/]*slurp/i
                    ],
                    describe: function() {
                        return {
                            name: "YahooSlurp"
                        };
                    }
                },
                {
                    test: [
                        /yandexbot/i,
                        /yandexmobilebot/i
                    ],
                    describe: function() {
                        return {
                            name: "YandexBot"
                        };
                    }
                },
                {
                    test: [
                        /pingdom/i
                    ],
                    describe: function() {
                        return {
                            name: "PingdomBot"
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = n.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /PaleMoon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Pale Moon"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:PaleMoon)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = n.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = n.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = n.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = n.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = n.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = n.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = n.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = n.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = n.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = n.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = n.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = n.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = n.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = n.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = n.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = n.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = n.default.getFirstMatch(a, e) || n.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = n.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = n.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = n.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /librewolf/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "LibreWolf"
                        }, r = n.default.getFirstMatch(/(?:librewolf)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = n.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = n.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sogoumobilebrowser/i,
                        /metasr/i,
                        /se 2\.[x]/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sogou Browser"
                        }, r = n.default.getFirstMatch(/(?:sogoumobilebrowser)[\s/](\d+(\.?_?\d+)+)/i, e), i = n.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e), a = n.default.getFirstMatch(/se ([\d.]+)x/i, e), o = r || i || a;
                        return o && (t.version = o), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = n.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return !!e.hasBrand("DuckDuckGo") || e.test(/\sDdg\/[\d.]+$/i);
                    },
                    describe: function(e, t) {
                        var r = {
                            name: "DuckDuckGo"
                        };
                        if (t) {
                            var i = t.getBrandVersion("DuckDuckGo");
                            if (i) return r.version = i, r;
                        }
                        var a = n.default.getFirstMatch(/\sDdg\/([\d.]+)$/i, e);
                        return a && (r.version = a), r;
                    }
                },
                {
                    test: function(e) {
                        return e.hasBrand("Brave");
                    },
                    describe: function(e, t) {
                        var r = {
                            name: "Brave"
                        };
                        if (t) {
                            var i = t.getBrandVersion("Brave");
                            if (i) return r.version = i, r;
                        }
                        return r;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = n.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = n.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = n.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = n.default.getFirstMatch(a, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: n.default.getFirstMatch(t, e),
                            version: n.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, a = r(18);
            var o = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: a.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = n.default.getWindowsVersionName(t);
                        return {
                            name: a.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: a.OS_MAP.iOS
                        }, r = n.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = n.default.getMacOSVersionName(t), i = {
                            name: a.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (i.versionName = r), i;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: a.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /OpenHarmony/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/OpenHarmony\s+(\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.HarmonyOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = n.default.getAndroidVersionName(t), i = {
                            name: a.OS_MAP.Android,
                            version: t
                        };
                        return r && (i.versionName = r), i;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: a.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || n.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || n.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: a.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: a.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: a.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: a.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, a = r(18);
            var o = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /linespider/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Line"
                        };
                    }
                },
                {
                    test: [
                        /amazonbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /gptbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "OpenAI"
                        };
                    }
                },
                {
                    test: [
                        /chatgpt-user/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "OpenAI"
                        };
                    }
                },
                {
                    test: [
                        /oai-searchbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "OpenAI"
                        };
                    }
                },
                {
                    test: [
                        /baiduspider/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Baidu"
                        };
                    }
                },
                {
                    test: [
                        /bingbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Bing"
                        };
                    }
                },
                {
                    test: [
                        /duckduckbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "DuckDuckGo"
                        };
                    }
                },
                {
                    test: [
                        /claudebot/i,
                        /claude-web/i,
                        /claude-user/i,
                        /claude-searchbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Anthropic"
                        };
                    }
                },
                {
                    test: [
                        /omgilibot/i,
                        /webzio-extended/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Webz.io"
                        };
                    }
                },
                {
                    test: [
                        /diffbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Diffbot"
                        };
                    }
                },
                {
                    test: [
                        /perplexitybot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Perplexity AI"
                        };
                    }
                },
                {
                    test: [
                        /perplexity-user/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Perplexity AI"
                        };
                    }
                },
                {
                    test: [
                        /youbot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "You.com"
                        };
                    }
                },
                {
                    test: [
                        /ia_archiver/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Internet Archive"
                        };
                    }
                },
                {
                    test: [
                        /meta-webindexer/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /meta-externalads/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /meta-externalagent/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /meta-externalfetcher/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /facebookexternalhit/i,
                        /facebookcatalog/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Meta"
                        };
                    }
                },
                {
                    test: [
                        /slackbot/i,
                        /slack-imgProxy/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Slack"
                        };
                    }
                },
                {
                    test: [
                        /yahoo/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Yahoo"
                        };
                    }
                },
                {
                    test: [
                        /yandexbot/i,
                        /yandexmobilebot/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Yandex"
                        };
                    }
                },
                {
                    test: [
                        /pingdom/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.bot,
                            vendor: "Pingdom"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /Nokia/i
                    ],
                    describe: function(e) {
                        var t = n.default.getFirstMatch(/Nokia\s+([0-9]+(\.[0-9]+)?)/i, e), r = {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Nokia"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: [
                        /smart-?tv|smarttv/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: [
                        /netcast/i
                    ],
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: a.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var i, n = (i = r(17)) && i.__esModule ? i : {
                default: i
            }, a = r(18);
            var o = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: a.ENGINE_MAP.Blink
                        };
                        var t = n.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: a.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: a.ENGINE_MAP.Trident
                        }, r = n.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: a.ENGINE_MAP.Presto
                        }, r = n.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: a.ENGINE_MAP.Gecko
                        }, r = n.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: a.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: a.ENGINE_MAP.WebKit
                        }, r = n.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = o, e.exports = t.default;
        }
    });
});

},{}],"46Exw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SUPPORTED_BROWSERS_BOWSER_CONFIG", ()=>SUPPORTED_BROWSERS_BOWSER_CONFIG);
parcelHelpers.export(exports, "MIN_SUPPORTED_BROWSER_VERSIONS", ()=>MIN_SUPPORTED_BROWSER_VERSIONS);
parcelHelpers.export(exports, "FLATPICKR_LOCALES", ()=>FLATPICKR_LOCALES);
var _itJs = require("flatpickr/dist/l10n/it.js");
var _esJs = require("flatpickr/dist/l10n/es.js");
var _frJs = require("flatpickr/dist/l10n/fr.js");
var _ru = require("flatpickr/dist/l10n/ru");
var _jaJs = require("flatpickr/dist/l10n/ja.js");
var _zhJs = require("flatpickr/dist/l10n/zh.js");
var _koJs = require("flatpickr/dist/l10n/ko.js");
var _arJs = require("flatpickr/dist/l10n/ar.js");
const SUPPORTED_BROWSERS_BOWSER_CONFIG = {
    chrome: ">=129",
    edge: ">=128",
    safari: ">=18"
};
const MIN_SUPPORTED_BROWSER_VERSIONS = {
    chrome: 129,
    edge: 128,
    safari: 18
};
const FLATPICKR_LOCALES = {
    it: (0, _itJs.Italian),
    es: (0, _esJs.Spanish),
    fr: (0, _frJs.French),
    ru: (0, _ru.Russian),
    ja: (0, _jaJs.Japanese),
    zh: (0, _zhJs.Mandarin),
    ko: (0, _koJs.Korean),
    ar: (0, _arJs.Arabic)
};

},{"flatpickr/dist/l10n/it.js":"aAHfs","flatpickr/dist/l10n/es.js":"dZaLg","flatpickr/dist/l10n/fr.js":"bN54Z","flatpickr/dist/l10n/ru":"7OvZ9","flatpickr/dist/l10n/ja.js":"1x5MB","flatpickr/dist/l10n/zh.js":"7cqFO","flatpickr/dist/l10n/ko.js":"bplYI","flatpickr/dist/l10n/ar.js":"jk7KZ","@parcel/transformer-js/src/esmodule-helpers.js":"iM2Jf"}],"aAHfs":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var Italian = {
        weekdays: {
            shorthand: [
                "Dom",
                "Lun",
                "Mar",
                "Mer",
                "Gio",
                "Ven",
                "Sab"
            ],
            longhand: [
                "Domenica",
                "Luned\xec",
                "Marted\xec",
                "Mercoled\xec",
                "Gioved\xec",
                "Venerd\xec",
                "Sabato"
            ]
        },
        months: {
            shorthand: [
                "Gen",
                "Feb",
                "Mar",
                "Apr",
                "Mag",
                "Giu",
                "Lug",
                "Ago",
                "Set",
                "Ott",
                "Nov",
                "Dic"
            ],
            longhand: [
                "Gennaio",
                "Febbraio",
                "Marzo",
                "Aprile",
                "Maggio",
                "Giugno",
                "Luglio",
                "Agosto",
                "Settembre",
                "Ottobre",
                "Novembre",
                "Dicembre"
            ]
        },
        firstDayOfWeek: 1,
        ordinal: function() {
            return "\xb0";
        },
        rangeSeparator: " al ",
        weekAbbreviation: "Se",
        scrollTitle: "Scrolla per aumentare",
        toggleTitle: "Clicca per cambiare",
        time_24hr: true
    };
    fp.l10ns.it = Italian;
    var it = fp.l10ns;
    exports1.Italian = Italian;
    exports1.default = it;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

},{}],"dZaLg":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var Spanish = {
        weekdays: {
            shorthand: [
                "Dom",
                "Lun",
                "Mar",
                "Mi\xe9",
                "Jue",
                "Vie",
                "S\xe1b"
            ],
            longhand: [
                "Domingo",
                "Lunes",
                "Martes",
                "Mi\xe9rcoles",
                "Jueves",
                "Viernes",
                "S\xe1bado"
            ]
        },
        months: {
            shorthand: [
                "Ene",
                "Feb",
                "Mar",
                "Abr",
                "May",
                "Jun",
                "Jul",
                "Ago",
                "Sep",
                "Oct",
                "Nov",
                "Dic"
            ],
            longhand: [
                "Enero",
                "Febrero",
                "Marzo",
                "Abril",
                "Mayo",
                "Junio",
                "Julio",
                "Agosto",
                "Septiembre",
                "Octubre",
                "Noviembre",
                "Diciembre"
            ]
        },
        ordinal: function() {
            return "\xba";
        },
        firstDayOfWeek: 1,
        rangeSeparator: " a ",
        time_24hr: true
    };
    fp.l10ns.es = Spanish;
    var es = fp.l10ns;
    exports1.Spanish = Spanish;
    exports1.default = es;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

},{}],"bN54Z":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var French = {
        firstDayOfWeek: 1,
        weekdays: {
            shorthand: [
                "dim",
                "lun",
                "mar",
                "mer",
                "jeu",
                "ven",
                "sam"
            ],
            longhand: [
                "dimanche",
                "lundi",
                "mardi",
                "mercredi",
                "jeudi",
                "vendredi",
                "samedi"
            ]
        },
        months: {
            shorthand: [
                "janv",
                "f\xe9vr",
                "mars",
                "avr",
                "mai",
                "juin",
                "juil",
                "ao\xfbt",
                "sept",
                "oct",
                "nov",
                "d\xe9c"
            ],
            longhand: [
                "janvier",
                "f\xe9vrier",
                "mars",
                "avril",
                "mai",
                "juin",
                "juillet",
                "ao\xfbt",
                "septembre",
                "octobre",
                "novembre",
                "d\xe9cembre"
            ]
        },
        ordinal: function(nth) {
            if (nth > 1) return "";
            return "er";
        },
        rangeSeparator: " au ",
        weekAbbreviation: "Sem",
        scrollTitle: "D\xe9filer pour augmenter la valeur",
        toggleTitle: "Cliquer pour basculer",
        time_24hr: true
    };
    fp.l10ns.fr = French;
    var fr = fp.l10ns;
    exports1.French = French;
    exports1.default = fr;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

},{}],"7OvZ9":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var Russian = {
        weekdays: {
            shorthand: [
                "\u0412\u0441",
                "\u041F\u043D",
                "\u0412\u0442",
                "\u0421\u0440",
                "\u0427\u0442",
                "\u041F\u0442",
                "\u0421\u0431"
            ],
            longhand: [
                "\u0412\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
                "\u041F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
                "\u0412\u0442\u043E\u0440\u043D\u0438\u043A",
                "\u0421\u0440\u0435\u0434\u0430",
                "\u0427\u0435\u0442\u0432\u0435\u0440\u0433",
                "\u041F\u044F\u0442\u043D\u0438\u0446\u0430",
                "\u0421\u0443\u0431\u0431\u043E\u0442\u0430"
            ]
        },
        months: {
            shorthand: [
                "\u042F\u043D\u0432",
                "\u0424\u0435\u0432",
                "\u041C\u0430\u0440\u0442",
                "\u0410\u043F\u0440",
                "\u041C\u0430\u0439",
                "\u0418\u044E\u043D\u044C",
                "\u0418\u044E\u043B\u044C",
                "\u0410\u0432\u0433",
                "\u0421\u0435\u043D",
                "\u041E\u043A\u0442",
                "\u041D\u043E\u044F",
                "\u0414\u0435\u043A"
            ],
            longhand: [
                "\u042F\u043D\u0432\u0430\u0440\u044C",
                "\u0424\u0435\u0432\u0440\u0430\u043B\u044C",
                "\u041C\u0430\u0440\u0442",
                "\u0410\u043F\u0440\u0435\u043B\u044C",
                "\u041C\u0430\u0439",
                "\u0418\u044E\u043D\u044C",
                "\u0418\u044E\u043B\u044C",
                "\u0410\u0432\u0433\u0443\u0441\u0442",
                "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
                "\u041E\u043A\u0442\u044F\u0431\u0440\u044C",
                "\u041D\u043E\u044F\u0431\u0440\u044C",
                "\u0414\u0435\u043A\u0430\u0431\u0440\u044C"
            ]
        },
        firstDayOfWeek: 1,
        ordinal: function() {
            return "";
        },
        rangeSeparator: " \u2014 ",
        weekAbbreviation: "\u041D\u0435\u0434.",
        scrollTitle: "\u041F\u0440\u043E\u043A\u0440\u0443\u0442\u0438\u0442\u0435 \u0434\u043B\u044F \u0443\u0432\u0435\u043B\u0438\u0447\u0435\u043D\u0438\u044F",
        toggleTitle: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F",
        amPM: [
            "\u0414\u041F",
            "\u041F\u041F"
        ],
        yearAriaLabel: "\u0413\u043E\u0434",
        time_24hr: true
    };
    fp.l10ns.ru = Russian;
    var ru = fp.l10ns;
    exports1.Russian = Russian;
    exports1.default = ru;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

},{}],"1x5MB":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var Japanese = {
        weekdays: {
            shorthand: [
                "\u65E5",
                "\u6708",
                "\u706B",
                "\u6C34",
                "\u6728",
                "\u91D1",
                "\u571F"
            ],
            longhand: [
                "\u65E5\u66DC\u65E5",
                "\u6708\u66DC\u65E5",
                "\u706B\u66DC\u65E5",
                "\u6C34\u66DC\u65E5",
                "\u6728\u66DC\u65E5",
                "\u91D1\u66DC\u65E5",
                "\u571F\u66DC\u65E5"
            ]
        },
        months: {
            shorthand: [
                "1\u6708",
                "2\u6708",
                "3\u6708",
                "4\u6708",
                "5\u6708",
                "6\u6708",
                "7\u6708",
                "8\u6708",
                "9\u6708",
                "10\u6708",
                "11\u6708",
                "12\u6708"
            ],
            longhand: [
                "1\u6708",
                "2\u6708",
                "3\u6708",
                "4\u6708",
                "5\u6708",
                "6\u6708",
                "7\u6708",
                "8\u6708",
                "9\u6708",
                "10\u6708",
                "11\u6708",
                "12\u6708"
            ]
        },
        time_24hr: true,
        rangeSeparator: " \u304B\u3089 ",
        monthAriaLabel: "\u6708",
        amPM: [
            "\u5348\u524D",
            "\u5348\u5F8C"
        ],
        yearAriaLabel: "\u5E74",
        hourAriaLabel: "\u6642\u9593",
        minuteAriaLabel: "\u5206"
    };
    fp.l10ns.ja = Japanese;
    var ja = fp.l10ns;
    exports1.Japanese = Japanese;
    exports1.default = ja;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

},{}],"7cqFO":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var Mandarin = {
        weekdays: {
            shorthand: [
                "\u5468\u65E5",
                "\u5468\u4E00",
                "\u5468\u4E8C",
                "\u5468\u4E09",
                "\u5468\u56DB",
                "\u5468\u4E94",
                "\u5468\u516D"
            ],
            longhand: [
                "\u661F\u671F\u65E5",
                "\u661F\u671F\u4E00",
                "\u661F\u671F\u4E8C",
                "\u661F\u671F\u4E09",
                "\u661F\u671F\u56DB",
                "\u661F\u671F\u4E94",
                "\u661F\u671F\u516D"
            ]
        },
        months: {
            shorthand: [
                "\u4E00\u6708",
                "\u4E8C\u6708",
                "\u4E09\u6708",
                "\u56DB\u6708",
                "\u4E94\u6708",
                "\u516D\u6708",
                "\u4E03\u6708",
                "\u516B\u6708",
                "\u4E5D\u6708",
                "\u5341\u6708",
                "\u5341\u4E00\u6708",
                "\u5341\u4E8C\u6708"
            ],
            longhand: [
                "\u4E00\u6708",
                "\u4E8C\u6708",
                "\u4E09\u6708",
                "\u56DB\u6708",
                "\u4E94\u6708",
                "\u516D\u6708",
                "\u4E03\u6708",
                "\u516B\u6708",
                "\u4E5D\u6708",
                "\u5341\u6708",
                "\u5341\u4E00\u6708",
                "\u5341\u4E8C\u6708"
            ]
        },
        rangeSeparator: " \u81F3 ",
        weekAbbreviation: "\u5468",
        scrollTitle: "\u6EDA\u52A8\u5207\u6362",
        toggleTitle: "\u70B9\u51FB\u5207\u6362 12/24 \u5C0F\u65F6\u65F6\u5236"
    };
    fp.l10ns.zh = Mandarin;
    var zh = fp.l10ns;
    exports1.Mandarin = Mandarin;
    exports1.default = zh;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

},{}],"bplYI":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var Korean = {
        weekdays: {
            shorthand: [
                "\uC77C",
                "\uC6D4",
                "\uD654",
                "\uC218",
                "\uBAA9",
                "\uAE08",
                "\uD1A0"
            ],
            longhand: [
                "\uC77C\uC694\uC77C",
                "\uC6D4\uC694\uC77C",
                "\uD654\uC694\uC77C",
                "\uC218\uC694\uC77C",
                "\uBAA9\uC694\uC77C",
                "\uAE08\uC694\uC77C",
                "\uD1A0\uC694\uC77C"
            ]
        },
        months: {
            shorthand: [
                "1\uC6D4",
                "2\uC6D4",
                "3\uC6D4",
                "4\uC6D4",
                "5\uC6D4",
                "6\uC6D4",
                "7\uC6D4",
                "8\uC6D4",
                "9\uC6D4",
                "10\uC6D4",
                "11\uC6D4",
                "12\uC6D4"
            ],
            longhand: [
                "1\uC6D4",
                "2\uC6D4",
                "3\uC6D4",
                "4\uC6D4",
                "5\uC6D4",
                "6\uC6D4",
                "7\uC6D4",
                "8\uC6D4",
                "9\uC6D4",
                "10\uC6D4",
                "11\uC6D4",
                "12\uC6D4"
            ]
        },
        ordinal: function() {
            return "\uC77C";
        },
        rangeSeparator: " ~ ",
        amPM: [
            "\uC624\uC804",
            "\uC624\uD6C4"
        ]
    };
    fp.l10ns.ko = Korean;
    var ko = fp.l10ns;
    exports1.Korean = Korean;
    exports1.default = ko;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

},{}],"jk7KZ":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports);
})(this, function(exports1) {
    'use strict';
    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
        l10ns: {}
    };
    var Arabic = {
        weekdays: {
            shorthand: [
                "\u0623\u062D\u062F",
                "\u0627\u062B\u0646\u064A\u0646",
                "\u062B\u0644\u0627\u062B\u0627\u0621",
                "\u0623\u0631\u0628\u0639\u0627\u0621",
                "\u062E\u0645\u064A\u0633",
                "\u062C\u0645\u0639\u0629",
                "\u0633\u0628\u062A"
            ],
            longhand: [
                "\u0627\u0644\u0623\u062D\u062F",
                "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
                "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
                "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
                "\u0627\u0644\u062E\u0645\u064A\u0633",
                "\u0627\u0644\u062C\u0645\u0639\u0629",
                "\u0627\u0644\u0633\u0628\u062A"
            ]
        },
        months: {
            shorthand: [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ],
            longhand: [
                "\u064A\u0646\u0627\u064A\u0631",
                "\u0641\u0628\u0631\u0627\u064A\u0631",
                "\u0645\u0627\u0631\u0633",
                "\u0623\u0628\u0631\u064A\u0644",
                "\u0645\u0627\u064A\u0648",
                "\u064A\u0648\u0646\u064A\u0648",
                "\u064A\u0648\u0644\u064A\u0648",
                "\u0623\u063A\u0633\u0637\u0633",
                "\u0633\u0628\u062A\u0645\u0628\u0631",
                "\u0623\u0643\u062A\u0648\u0628\u0631",
                "\u0646\u0648\u0641\u0645\u0628\u0631",
                "\u062F\u064A\u0633\u0645\u0628\u0631"
            ]
        },
        firstDayOfWeek: 6,
        rangeSeparator: " \u0625\u0644\u0649 ",
        weekAbbreviation: "Wk",
        scrollTitle: "\u0642\u0645 \u0628\u0627\u0644\u062A\u0645\u0631\u064A\u0631 \u0644\u0644\u0632\u064A\u0627\u062F\u0629",
        toggleTitle: "\u0627\u0636\u063A\u0637 \u0644\u0644\u062A\u0628\u062F\u064A\u0644",
        amPM: [
            "\u0635",
            "\u0645"
        ],
        yearAriaLabel: "\u0633\u0646\u0629",
        monthAriaLabel: "\u0634\u0647\u0631",
        hourAriaLabel: "\u0633\u0627\u0639\u0629",
        minuteAriaLabel: "\u062F\u0642\u064A\u0642\u0629",
        time_24hr: false
    };
    fp.l10ns.ar = Arabic;
    var ar = fp.l10ns;
    exports1.Arabic = Arabic;
    exports1.default = ar;
    Object.defineProperty(exports1, '__esModule', {
        value: true
    });
});

},{}],"iM2Jf":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}]},["6kDkD"], "6kDkD", "parcelRequire8812", {})

//# sourceMappingURL=logging.js.map
